import React from "react";

import { usePaiementSettings } from "./hooks/usePaiementSettings";

import PaiementHeader from "./components/PaiementHeader";
import PaiementSettingsCard from "./components/PaiementSettingsCard";
import PaiementDefaultImageCard from "./components/PaiementDefaultImageCard";
import PaiementImageUploadModal from "./components/PaiementImageUploadModal";

export default function SettingsPaiements() {
  const dashboard = usePaiementSettings();

  const formId = "paiement-settings-form";

  return (
    <div className="space-y-5">
      <PaiementHeader
        formId={formId}
        loading={dashboard.loading}
        saving={dashboard.saving}
      />

      <PaiementSettingsCard
        formId={formId}
        settings={dashboard.settings}
        loading={dashboard.loading}
        saving={dashboard.saving}
        onChange={dashboard.handleChange}
        onSubmit={dashboard.handleSubmit}
      />

      <PaiementDefaultImageCard
        imageSrc={dashboard.imageSrc}
        imageUrl={dashboard.settings.photo_url_default_lic_cot}
        loading={dashboard.loading}
        onOpenUpload={dashboard.openUploadModal}
      />

      <PaiementImageUploadModal
        isOpen={dashboard.isUploadModalOpen}
        uploading={dashboard.uploading}
        uploadProgress={dashboard.uploadProgress}
        selectedFile={dashboard.selectedFile}
        filePreview={dashboard.filePreview}
        outputFormat={dashboard.outputFormat}
        setOutputFormat={dashboard.setOutputFormat}
        onClose={dashboard.closeUploadModal}
        onFileChange={dashboard.handleFileChange}
        onSubmit={dashboard.handleUploadSubmit}
      />
    </div>
  );
}